<div class="guide-share-wrapper" (click)="close()">
  <!-- <div class="txt">请点击右上角 “...” </div> -->
  <div class="img">
    <img src="/assets/imgs/guide/guide-share.png"/>
  </div>
</div>